module.exports = __webpack_public_path__ + "img/love.f191154b.svg";